const MUI_X_PREMIUM_KEY =
  'e3b87d4fd614353326af922a5a426a66Tz0xMTcyOTksRT0xNzg2MDYwNzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=';

export const getMuiXKey = () => {
  if (
    'VITE_APP_MUI_X_PREMIUM_LICENSE_KEY' in import.meta.env &&
    typeof import.meta.env.VITE_APP_MUI_X_PREMIUM_LICENSE_KEY === 'string'
  )
    return import.meta.env.VITE_APP_MUI_X_PREMIUM_LICENSE_KEY satisfies string;

  return MUI_X_PREMIUM_KEY;
};
